import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  type: string;
  name: string;
  columns?: string[];
};
export const useSchemaTable = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingTables = projectData.tables
    .map((table) => table.name?.toLocaleLowerCase())
    .filter((table) => table !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingTables, t('addTables.existing'))
          .max(250),
        type: Yup.string(),
        columns: Yup.array().min(1).required(),
      }),
    [t, existingTables],
  );
};
